import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Outlet } from 'react-router';
import { TopNav } from './TopNav';
import { Sidebar } from './Sidebar';
import { MeshBackground } from './MeshBackground';
/**
 * The authenticated layout shell. Structure mirrors the Chaosology mockup:
 *
 *   ┌────────────────────────────────────────┐
 *   │              topnav (68px)              │
 *   ├──────────┬──────────────────────────────┤
 *   │ sidebar  │           main               │
 *   │  272px   │         (scroll)             │
 *   └──────────┴──────────────────────────────┘
 *
 * The pastel `<MeshBackground />` sits fixed behind everything so the
 * glass surfaces have something interesting to blur over.
 *
 * On ≤1200px the sidebar hides and the main column fills the row — the
 * hamburger-drawer replacement is a Phase 3 todo (spec §6.4).
 */
export function AppShell() {
    return (_jsxs(_Fragment, { children: [_jsx(MeshBackground, {}), _jsxs("div", { className: "relative z-[1] grid min-h-screen mx-auto max-w-[1680px]", style: {
                    gridTemplateColumns: '272px 1fr',
                    gridTemplateRows: '68px 1fr',
                    gridTemplateAreas: `"nav nav" "side main"`,
                }, children: [_jsx("a", { href: "#main-content", className: "skip-link", children: "Skip to content" }), _jsx(TopNav, {}), _jsx(Sidebar, {}), _jsx("main", { id: "main-content", className: "overflow-y-auto px-9 pt-6 pb-20", style: { gridArea: 'main' }, children: _jsx(Outlet, {}) })] })] }));
}
